/* Gallery controls stay local to each product section, including editor reloads. */
if (!customElements.get('rd-shop-gallery')) {
  customElements.define('rd-shop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const main = this.querySelector('.rd-gallery__main');
      const dialog = this.querySelector('dialog');
      const enlarged = dialog.querySelector('img');
      const thumbnails = [...this.querySelectorAll('.rd-gallery__thumb')];
      thumbnails.forEach((button) => button.addEventListener('click', () => {
        main.src = enlarged.src = button.dataset.src;
        main.alt = enlarged.alt = button.dataset.alt;

        thumbnails.forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
      }));
      this.querySelector('.rd-gallery__zoom').addEventListener('click', () => dialog.showModal());
      this.querySelector('.rd-gallery__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    }
  });
}

if (!customElements.get('rd-planning-calculator')) {
  customElements.define('rd-planning-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('input');
      const buttons = [...this.querySelectorAll('[data-unit]')];
      const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
      let unit = 'lb';
      const bounds = () => unit === 'kg' ? [45, 145] : [100, 320];
      const render = (normalize = false) => {
        const value = Number.parseFloat(input.value);
        const [min, max] = bounds();
        const valid = Number.isFinite(value) && value >= min && value <= max;
        if (normalize && Number.isFinite(value)) input.value = Math.round(clamp(value, min, max));
        if (!valid && !normalize) {
          this.querySelector('[data-result="days"]').textContent = '—';
          this.querySelector('[data-result="bottles"]').textContent = '—';
          this.querySelector('[data-validation]').textContent = `Enter a weight from ${min} to ${max} ${unit}.`;
          return;
        }
        if (!Number.isFinite(value)) return;
        this.querySelector('[data-validation]').textContent = '';
        const pounds = clamp(Number(input.value) * (unit === 'kg' ? 2.2046226218 : 1), 100, 320);
        // Retains the store's existing weight-based estimate; not a clinical prediction.
        const estimate = pounds <= 130 ? 5 : pounds < 160 ? 6 : pounds <= 220 ? 6 + (pounds - 160) / 60 : 7 + (pounds - 220) / 50;
        const days = Math.ceil(estimate - 0.01);
        this.querySelector('[data-result="days"]').textContent = days;
        this.querySelector('[data-result="bottles"]').textContent = Math.max(1, Math.ceil(days / 7));
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        if (button.dataset.unit === unit) return;
        const value = Number.parseFloat(input.value);
        const pounds = value * (unit === 'kg' ? 2.2046226218 : 1);
        unit = button.dataset.unit;
        if (Number.isFinite(value)) input.value = Math.round(pounds / (unit === 'kg' ? 2.2046226218 : 1));
        [input.min, input.max] = bounds();
        this.querySelector('[data-unit-label]').textContent = unit;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        render(true);
      }));
      this.querySelectorAll('[data-step]').forEach((button) => button.addEventListener('click', () => {
        const [min, max] = bounds();
        input.value = clamp((Number.parseFloat(input.value) || min) + Number(button.dataset.step) * (unit === 'kg' ? 2 : 5), min, max);
        render(true);
      }));
      input.addEventListener('input', () => render());
      input.addEventListener('change', () => render(true));
      render();
    }
  });
}

